import React, { Fragment, useEffect, useState } from 'react';
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import Moment from 'react-moment';
import { compareByName, uStripHtmlTags } from '../../../utils/helpers';
import { deleteAdminBanner, loadAdminBanners } from '../../../actions/Notifications/AdminBanners';
import Constants from '../../../Constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { onSuccessMsg } from '../../../actions/FlashMessage/FlashMessages';
import { ModalContainer } from '../../Common';

const BannersTable = ({ banners, isActiveBanners }) => {
  const [sortBy, setSortBy] = useState({ key: '', order: '' });
  const [tableItems, setTableItems] = useState([]);
  const [bannerSelectedMsg, setBannerSelectedMsg] = useState('');
  const [activeBannerId, setActiveBannerId] = useState('');
  const { formatDate } = Constants;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function sortTableByTitle(columnName) {
    let orderToSort = '';
    if (sortBy.key !== columnName || sortBy.order === '') {
      orderToSort = 'up';
      tableItems.sort((a, b) => compareByName(a, b, columnName));
      setTableItems([...tableItems]);
    } else if (sortBy.order === 'up') {
      tableItems.reverse();
      setTableItems([...tableItems]);
      orderToSort = 'down';
    } else {
      setTableItems(copyTableItems(banners));
    }
    setSortBy({ ...sortBy, order: orderToSort, key: columnName });
  }

  const showConfirmOnDelete = (banner) => {
    setBannerSelectedMsg(banner.message);
    setActiveBannerId(banner.id);
    setShowDeleteModal(true);
  };

  const copyTableItems = (items) => {
    return items.map((item) => {
      return {
        ...item,
        startDate: new Date(item.startDate),
        endDate: new Date(item.endDate),
        userRolesDisplay: item.userRolesDisplay.join(', '),
      };
    });
  };

  const onSubmit = async () => {
    await dispatch(deleteAdminBanner(activeBannerId));
    await dispatch(loadAdminBanners());
    setShowDeleteModal(false);
    setActiveBannerId();
    // TODO: temporary solution to show message on the Layout after we move to the list
    setTimeout(() => {
      dispatch(onSuccessMsg(`Banner message successfully deleted.`));
    }, 0);
  };

  const arrowStatusOrderIcon = (titleKey) => (
    <i className={`absolute pLeft-5 pTop-2 fas fa-caret-${sortBy.key === titleKey ? sortBy.order : ''}`} />
  );

  useEffect(() => {
    loadAdminBanners();
  }, []);

  useEffect(() => {
    setTableItems(copyTableItems(banners));
  }, [banners]);

  return (
    <React.Fragment>
      <Table className={'notifications-table'}>
        <Thead>
          <Tr>
            <Th onClick={() => sortTableByTitle('message')} data-testid="sort-by-msg">Message {arrowStatusOrderIcon('message')}</Th>
            <Th onClick={() => sortTableByTitle('startDate')} data-testid="sort-by-display">Displayed Between {arrowStatusOrderIcon('startDate')}</Th>
            <Th onClick={() => sortTableByTitle('userRolesDisplay')}  data-testid="sort-by-role">
              Users {arrowStatusOrderIcon('userRolesDisplay')}
            </Th>
            {isActiveBanners && (
              <Fragment>
                <Th onClick={() => sortTableByTitle('status')} data-testid="sort-by-status">Status {arrowStatusOrderIcon('status')}</Th>
                <Th aria-hidden></Th>
              </Fragment>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {tableItems.length ? (
            tableItems.map((banner, index) => {
              return (
                <Tr key={index}>
                  <Td className="message">
                    <div id={`message${index}`} dangerouslySetInnerHTML={{ __html: banner.message }} />
                  </Td>
                  <Td className="date-between">
                    <div>
                      <Moment format={formatDate}>{banner.startDate}</Moment>&nbsp;-&nbsp;
                      <Moment format={formatDate}>{banner.endDate}</Moment>
                    </div>
                  </Td>
                  <Td className="role-display">
                    <div>{banner.userRolesDisplay}</div>
                  </Td>

                  {isActiveBanners && (
                    <Fragment>
                      <Td className="status">
                        <div className={`${banner.status.toLowerCase()}`}>{banner.status}</div>
                      </Td>
                      <Td className="table-actions">
                        <div>
                          <button
                            aria-label={`Edit Banner`}
                            aria-describedby={`message${index}`}
                            onClick={() => {
                              navigate(`/addBanner/${banner.id}`);
                            }}>
                            <i className="far fa-pencil lsn-primary-color" />
                          </button>
                          <button
                            aria-label={`Delete Banner`}
                            aria-describedby={`message${index}`}
                            onClick={() => {
                              showConfirmOnDelete(banner);
                            }}
                            data-testid={`delete-banner-${banner.id}`}>
                            <i className="far fa-trash-alt" />
                          </button>
                        </div>
                      </Td>
                    </Fragment>
                  )}
                </Tr>
              );
            })
          ) : (
            <Tr>
              <Td colSpan="4">There are no active or scheduled banner messages.</Td>
            </Tr>
          )}
        </Tbody>
      </Table>
      <ModalContainer
        isOpen={showDeleteModal}
        size="small"
        title="Delete Banner Message"
        text={
          <React.Fragment>
            Are you sure you want to delete this Banner Message?
            <br />
            <b>{uStripHtmlTags(bannerSelectedMsg)}</b>
            <br />
            This action cannot be undone.
          </React.Fragment>
        }
        btnSubmitText="Delete"
        onSubmit={onSubmit}
        onCancel={() => {
          setActiveBannerId();
          setShowDeleteModal(false);
        }}
      />
    </React.Fragment>
  );
};

export default BannersTable;
